const MyTooltip = ({ title, arrow, children }) => children

export default MyTooltip
